module.exports = __webpack_public_path__ + "imoje.png?dce1b49165aa581162ea3e2b0d0a5750";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/imoje.png
// module id = Xtfh
// module chunks = 50